import React, { FC } from 'react';
import TextComponentDecider from '../../TextComponentDecider';
import { getTextType } from '../../../../utils/getTextType.utils';
import { ComponentRendering, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import { TFeatureHeaderProps } from '../types/productFeatureComponent.types';

const FeatureHeader: FC<TFeatureHeaderProps> = (props) => {
  const { title, isEEActive, titleDictionaryKeyFeature, rendering } = props;
  return (
    <div className="product-feature__header">
        <TextComponentDecider
          type={getTextType('Text', !title)}
          tag={'p'}
          field={{ value: title }}
          className="product-feature__title"
          dictionaryKey={titleDictionaryKeyFeature}
        />
      <div className={`${isEEActive ? 'product-feature__popup generic-popupEE-width' : ''}`}>
        <Placeholder name={'jss-generic-popup'} rendering={rendering as ComponentRendering} />
      </div>
    </div>
  );
};

export default FeatureHeader;
